import { useQuery } from '@tanstack/react-query'
import { NAVIGATION_QUERY_STALE_TIME_MS } from '@/constants'
import { tablesQueryKeys } from '../api/queryKeys'
import { getTableCapabilities } from '../api/tables.api'

/** Fetched with the navigation (ConfigurationController), so Add table never pops in. */
export const tableCapabilitiesQuery = {
  queryKey: tablesQueryKeys.capabilities,
  queryFn: getTableCapabilities,
  staleTime: NAVIGATION_QUERY_STALE_TIME_MS,
} as const

/**
 * Whether the signed-in user may create tables (the Create Table permission).
 * False until known, so Add table is left out rather than offered and refused.
 */
export function useCanCreateTables(): boolean {
  const { data } = useQuery(tableCapabilitiesQuery)
  return data?.can_create === true
}
